export const ROUTER = {
    HOME:'/',
    HELP:'/help',
    RULES:'/rules',
    FAVORITES:'/favorites',
    DOWNLOAD:'/download',
    CATEGORY:'/category/:categoryName',
    PROFILE:'/profile',
    SETTING:'/setting',
    SHOW_MORE_PRODUCT:'/show-more-product',
    SHOW_MORE_COLLECTION:'/show-more-collection',
    SHOW_SINGLE_COLLECTION: '/show-single-collection'   ,
    SHOW_MORE_SINGLE_COLLECTION: '/show-more-single-collection'   
}